import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";
import { MEDIUM_ITEM_SIZE } from "./_fields";
import { validatePlainText, validateDate } from "./_utils";

type AccidentInvestigationRecordTemplate = {
  eMajor: string;
  eSubject: string;
  eTrainingCourse: string;
  eTrainingType: string;
  // eTrainees: string;
  eTraineeObject: string;
  // eLessonTypes: string;
  eDateFrom: string;
  eDateTo: string;
  // eCoursePlaces: string;
  // eCourseTrainee: string;
  eNotes: string;
};

const currentDate = new Date();
const tomorrow = new Date();
tomorrow.setDate(currentDate.getDate() + 1);

export const monthlyTrainingPlanTemplate: TemplatesValue<AccidentInvestigationRecordTemplate> =
  {
    fileName: "DanhSachKhoaHoc",
    sheet: DEFAULT_SHEET_NAME,
    structures: [
      {
        header: "Nghiệp vụ",
        value: "ĐIỀU KHIỂN XE/ MOOC BĂNG CHUYỀN",
        itemSize: MEDIUM_ITEM_SIZE,
        validate: validatePlainText,
      },
      {
        header: "Môn học",
        value: "Kiểm tra",
        itemSize: MEDIUM_ITEM_SIZE,
        validate: validatePlainText,
      },
      {
        header: "Khoá đào tạo",
        value: "Đào tạo IOSA",
        itemSize: MEDIUM_ITEM_SIZE,
        validate: validatePlainText,
      },
      {
        header: "Loại hình đào tạo",
        value: "ĐỊNH KỲ",
        itemSize: MEDIUM_ITEM_SIZE,
        validate: validatePlainText,
      },
      // {
      //   header: "Học viên",
      //   value: "VIAGS(3),VNA(2)",
      //   itemSize: MEDIUM_ITEM_SIZE,
      //   validate: validatePlainText,
      // },
      {
        header: "Đối tượng",
        value: "Đối tượng 1",
        itemSize: MEDIUM_ITEM_SIZE,
        validate: validatePlainText,
      },
      // {
      //   header: "Thời lượng",
      //   value: "EL(1),TT(5)",
      //   itemSize: MEDIUM_ITEM_SIZE,
      //   validate: validatePlainText,
      // },
      {
        header: "Từ ngày",
        value: tomorrow,
        itemSize: MEDIUM_ITEM_SIZE,
        validate: validateDate,
        style: { numFmt: "DD/MM/YYYY" },
      },
      {
        header: "Đến ngày",
        value: tomorrow,
        itemSize: MEDIUM_ITEM_SIZE,
        validate: validateDate,
        style: { numFmt: "DD/MM/YYYY" },
      },
      // {
      //   header: "Địa điểm",
      //   value: "TN(44),NN(222)",
      //   itemSize: MEDIUM_ITEM_SIZE,
      //   validate: validatePlainText,
      // },
      // {
      //   header: "Giáo viên/Đối tác",
      //   value: "Giáo viên 1",
      //   itemSize: MEDIUM_ITEM_SIZE,
      //   validate: validatePlainText,
      // },
      {
        header: "Ghi chú",
        value: "Ghi chú 1",
        itemSize: MEDIUM_ITEM_SIZE,
        validate: validatePlainText,
      },
    ],
    fields: [
      "eMajor",
      "eSubject",
      "eTrainingCourse",
      "eTrainingType",
      // "eTrainees",
      "eTraineeObject",
      // "eLessonTypes",
      "eDateFrom",
      "eDateTo",
      // "eCoursePlaces",
      // "eCourseTrainee",
      "eNotes",
    ],
  };
